module.exports = __webpack_public_path__ + "fonts/icomoon.86233586.ttf";